export const RESPONSE_STATUSES = {
    no_response: { label: 'No Response', color: 'var(--text-muted)' },
    accepted_time: { label: 'Accepted Time', color: 'var(--success)' },
    wants_other_time: { label: 'Wants Other Time', color: 'var(--warning)' },
    declined: { label: 'Declined', color: 'var(--error)' },
    has_questions: { label: 'Has Questions', color: 'var(--info)' },
    general_reply: { label: 'Replied', color: 'var(--primary)' },
};
